import Accordion from "@/common/components/Accordion";
import { Control, FieldErrors, useFieldArray } from "react-hook-form";
import { ErrorMessage } from "@/common/components/ErrorMessage";
import Box from "@/common/components/Box";
import MaintenanceObjective from "@/common/components/MaintenanceObjective";
import { WorkflowScheduleObjective } from "../types/workflowSchedules.type";
import { CreateWorkflowSchedulesObjectiveSchema, CreateWorkflowSchedulesSchema, workflowSchedulesObjectiveAttributes } from "../services/workflowSchedules.schema";
import { MaintenanceSolicitationObjectives } from "@/features/maintenanceSolicitations/components/MaintenanceSolicitationObjectives";
import { ModalAddMaintenanceObjective } from "@/features/maintenanceSolicitations/components/ModalAddMaintenanceObjective";

interface AccordionMaintenanceWorkflowSchedulesObjectivesProps {
  errors: FieldErrors<CreateWorkflowSchedulesSchema>
  control: Control<CreateWorkflowSchedulesSchema>
  objectives?: WorkflowScheduleObjective[]
  disabled?: boolean
}

export default function AccordionMaintenanceWorkflowSchedulesObjectives({ errors, control, objectives, disabled }: AccordionMaintenanceWorkflowSchedulesObjectivesProps) {
  const {
    fields: objectivesFields,
    append: appendObjective,
    remove: removeObjective,
  } = useFieldArray({
    control,
    name: 'objectives_attributes',
  })

  return (
    <Accordion
      name="maintenanceWorkflowSchedulesObjectives"
      head={
        <div className="flex w-full flex-col items-start gap-y-1">
          <p>
            Objetos de manutenção {!disabled && <span className="text-danger-soft"> *</span>}
          </p>

          {!!errors.objectives_attributes?.message && (
            <ErrorMessage name="objectives_attributes" message={errors.objectives_attributes?.message} />
          )}
        </div>
      }
      body={
        objectives ? (
          <div className="grid grid-cols-1 md:grid-cols-2 items-stretch justify-stretch gap-2">
            {objectives.map((objective) => (
              <Box key={objective.id} className="flex w-full flex-col items-start gap-y-2 rounded-lg">
                <MaintenanceObjective
                  systemDisplayName={objective.system.display_name}
                  actionDisplayName={objective.action.display_name}
                  partDisplayName={objective.part.display_name}
                  actionDescription={objective.action.description}
                />
              </Box>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 items-stretch justify-stretch gap-2">
            <ModalAddMaintenanceObjective<CreateWorkflowSchedulesObjectiveSchema>
              validationSchema={workflowSchedulesObjectiveAttributes}
              objectivesFields={objectivesFields}
              appendObjective={appendObjective}
              useEquipmentIdToFilterData={false}
              disabled={disabled}
            />

            <MaintenanceSolicitationObjectives
              objectivesFields={objectivesFields}
              removeObjective={removeObjective}
            />
          </div>
        )
      }
    />
  )
}
